import React, { useState, useCallback } from 'react';
import { Scale, Layers, BookCheck } from 'lucide-react';
// import { VoiceIndicator } from './components/VoiceIndicator';
import ControlTray from './components/control-tray/ControlTray';
import { LiveAPIProvider } from "./contexts/LiveAPIContext";
import './App.scss';
import { Altair } from './components/altair/Altair';

interface Note {
  id: number;
  content: string;
  timestamp: string;
}

const App = () => {
  const [isVoiceActive, setIsVoiceActive] = useState(false);
  const [notes, setNotes] = useState<Note[]>([]);

  console.log(notes, "notes");

  // Memoize the addNotes callback
  const collectDetails = useCallback((note: string) => {
    setNotes(prevNotes => {
      const newNote = {
        id: prevNotes.length + 1,
        content: note,
        timestamp: new Date().toLocaleTimeString()
      };
      return [...prevNotes, newNote];
    });
  }, []);

  // Memoize the getGrades callback
  const getGrades = useCallback((studentId: string) => {
    return Math.floor(Math.random() * (100 - 60 + 1)) + 60;
  }, []);

  const API_KEY = process.env.REACT_APP_GEMINI_API_KEY as string;
  if (typeof API_KEY !== "string") {
    throw new Error("set REACT_APP_GEMINI_API_KEY in .env");
  }
  
  const host = "generativelanguage.googleapis.com";
  const uri = `wss://${host}/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent`;
  return (
    <div className="app-container">
        <LiveAPIProvider url={uri} apiKey={API_KEY}>

      <header className="header">
        <div className="logo">
          <img src="https://globalindianschool.org/bangalore/wp-content/uploads/sites/26/2023/09/logo.svg" alt="GIIS Logo" className="giis-logo" />
          <div className="logo-text">
            <span className="school-name">Global Indian International School</span>
            <span className="ai-portal">AI Admin Portal</span>
          </div>
        </div>
        <div className="actions">
          <button className="action-button">
            <Layers className="action-icon" />
            <span>Dashboard</span>
          </button>
        </div>
      </header>

      <main className="main-content mt-4">
        <section className="case-notes">
          <div className="case-notes__header">
            <BookCheck />
            <span>Student Details</span>
          </div>
          <div className="case-notes__list">
            {notes.map((note) => (
              <div key={note.id} className="note-item">
                <div className="note-item__content">{note.content}</div>
                <div className="note-item__timestamp">{note.timestamp}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="case-summary">
          <div className="case-summary__header">
          
          </div>
        </section>
      </main>
      <Altair collectDetails={(note: string) => collectDetails(note)} getGrades={(studentId: string) => getGrades(studentId)} />

      <div className="voice-indicator">
        <ControlTray supportsVideo={false} />
      </div>
      </LiveAPIProvider>
    </div>
  );
};

export default App;